import { useRecoilValue } from "recoil";
import useSWR from "swr";
import { ifreaMediaAnalyticsDateRangeState } from "../../store/ifreaMediaAnalyticsDateRangeState";

export const useFetchHotPepperAnalytics = (restaurantId?: string) => {
  const dateRange = useRecoilValue(ifreaMediaAnalyticsDateRangeState)
  const fetcherKey = restaurantId ? `ifrea_analytics/restaurants/${restaurantId}/hot-pepper-analytics/?startDate=${dateRange.startDate}&endDate=${dateRange.endDate}` : null;
  const { data: hotPepperAnalytics, isLoading } = useSWR<any>(fetcherKey)
  return { hotPepperAnalytics, isLoading };
};